<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ grocer.title }}: Настройки</strong>
                </CCardHeader>
                <CCardBody>
                    <GrocerTabLinks />
                    <CRow v-if="settingsText" class="pl-3 pb-3 red" />
                    <CRow v-if="settingsText" class="pl-3 pb-3 red">{{ settingsText }}</CRow>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow class="pl-3 pb-3 h3">Комментарии</CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Комментарий про замены
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.use_comment"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="settings.use_comment">
                            <CCol col="12">
                                <CInput
                                    v-model="settings.comment_options[0]"
                                    label="Опции для выбора (вставка в конце комментария к заказу)"
                                    placeholder="Позвонить..."
                                />
                            </CCol>
                            <CCol col="12">
                                <CInput
                                    v-model="settings.comment_options[1]"
                                    placeholder="Заменить на аналог..."
                                />
                            </CCol>
                            <CCol col="12">
                                <CInput
                                    v-model="settings.comment_options[2]"
                                    placeholder="Вернуть деньги..."
                                />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3 h3">Корзина</CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Время доставки
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.enabled_delivery_time"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="12"
                                class="col-form-label">Поле для коментария</CCol>
                            <CCol class="d-flex align-items-center">
                                <template v-for="option in commentOptions">
                                    <CInputRadio
                                        :key="option.id"
                                        class="mb-0 ml-3 mr-0"
                                        inline
                                        name="comment"
                                        :value="option.id"
                                        :checked="selectedComment === option.id"
                                        @update:checked="updateCommentTime"
                                    /> {{ option.title }}
                                </template>
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="12"
                                class="col-form-label">Доставить/Заберу как можно раньше (ко времени)</CCol>
                            <CCol class="d-flex align-items-center">
                                <template v-for="option in deliveryOptions">
                                    <CInputRadio
                                        :key="option.id"
                                        class="mb-0 ml-3 mr-0"
                                        inline
                                        name="time"
                                        :value="option.id"
                                        :checked="selectedDelivery === option.id"
                                        @update:checked="updateDeliveryTime"
                                    /> {{ option.title }}
                                </template>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать текст под формой
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="settings.show_help_text"
                                />
                            </CCol>
                            <CCol>
                                <CTextarea 
                                    v-if="settings.show_help_text"
                                    v-model="settings.help_text"
                                    label="Текст под формой"
                                    placeholder="Укажите текст под формой (не более 255 символов)"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import { xssRegEx } from '@/utils/rules';

    export default {
        name: 'GrocerSettings',

        components: {
            GrocerTabLinks,
        },

        data() {
            return {
                grocer: {},
                settings: {
                    id: null,
                    grocer_id: null,
                    use_comment: false,
                    comment_options: [],
                    enabled_delivery_time: false,
                    show_address: false,
                    show_meeting_point: false,
                    show_comment: false,
                    show_large_comment: false,
                    show_delivery_time: false,
                    show_meeting_time: false,
                    show_help_text: false,
                    help_text: '',
                },
                settingsText: '',
                deliveryOptions: [
                    { id: 1, title: 'Доставить' },
                    { id: 2, title: 'Заберу' },
                    { id: 3, title: 'Не показывать информацию о доствке' },
                ],
                selectedDelivery: 3,
                commentOptions: [
                    { id: 1, title: 'Маленькое' },
                    { id: 2, title: 'Большое' },
                    { id: 3, title: 'Не показывать поле для коментария' },
                ],
                selectedComment: 3,
            };
        },

        computed: {},

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get(`/grocers/${id}`)
                .then(resp => {
                    this.grocer = resp.data;
                    this.settings.grocer_id = resp.data.id;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get(`/grocers/${id}/settings`)
                .then(resp => {
                    this.settings = { ...this.settings, ...resp.data };
                    this.getDeliveryCheck(this.settings);
                    this.getCommentCheck(this.settings);
                })
                .catch(e => {
                    console.log(e);
                    this.settingsText = 'Этот сервис использует стандартные настройки, выберите настройки и нажмите «Сохранить» что бы активировать кастомные настройки.';
                });

        },

        methods: {
            save() {
                if (xssRegEx.test(this.settings.help_text)) {
                    this.$root.$emit('showError', 'Текст под формой содержит недопустимые символы.')
                    return
                }
                this.settings.comment_options = this.settings.comment_options.filter(comment => !!comment);
                Vue.axios
                    .post(`/grocers/${this.$route.params.id}/settings`, this.settings)
                    .then(() => this.goBack())
                    .catch(err => this.$root.$emit('showError', 'Ошибка сохранения.'));
            },

            updateDeliveryTime(checked, obj) {
                for(let i = 0; i < this.deliveryOptions.length; i++) {
                    const condidate = this.deliveryOptions.find(option => option.id === +obj.target.value);
                    if (condidate.id === 1) {
                        this.settings.show_delivery_time = true;
                        this.settings.show_meeting_time = false;
                    } else if (condidate.id === 2) {
                        this.settings.show_meeting_time = true;
                        this.settings.show_delivery_time = false;
                    } else {
                        this.settings.show_meeting_time = false;
                        this.settings.show_delivery_time = false;
                    }
                }
            },

            updateCommentTime(checked, obj) {
                for(let i = 0; i < this.commentOptions.length; i++) {
                    const condidate = this.commentOptions.find(option => option.id === +obj.target.value);
                    if (condidate.id === 1) {
                        this.settings.show_comment = true;
                        this.settings.show_large_comment = false;
                    } else if (condidate.id === 2) {
                        this.settings.show_large_comment = true;
                        this.settings.show_comment = false;
                    } else {
                        this.settings.show_large_comment = false;
                        this.settings.show_comment = false;
                    }
                }
            },

            getDeliveryCheck(settings) {
                if (settings.show_delivery_time) {
                    this.selectedDelivery = 1;
                } else if (settings.show_meeting_time) {
                    this.selectedDelivery = 2;
                } else {
                    this.selectedDelivery = 3;
                }
            },

            getCommentCheck(settings) {
                if (settings.show_comment) {
                    this.selectedComment = 1;
                } else if (settings.show_large_comment) {
                    this.selectedComment = 2;
                } else {
                    this.selectedComment = 3;
                }
            },

            updateComment() {
                this.settings.show_comment = false;
                this.settings.show_large_comment = false;
            },

            goBack() {
                const path = `/grocers/${this.$route.params.id}`;
                this.$router.push({ path });
            },
        },
    };
</script>
<style scoped>
.red {
    color: red;
}
</style>
